import React, { useContext } from 'react'
import { CoreContext } from 'context/CoreContext'
import { ThemedComponent } from 'ui/theme'

import ModalSample from '../Sample'
import ModalFeedBack from '../FeedBack'
import ModalNewTicket from '../NewTicket'
import ModalTerm from '../Term'
import ModalWelcome from '../Welcome'
import ModalShare from '../Share'
import ModalUpload from '../Upload'
import ModalPdfPreview from '../PdfPreview'
import ModalWebNotification from '../WebNotification'
import ModalExclusiveContent from '../ExclusiveContent'

export default function ModalCore() {

  const { modal } = useContext(CoreContext)

  return (
    <>
      <ThemedComponent>
        {modal?.type === 'sample' ? <ModalSample /> : null}
        {modal?.type === 'feedback' ? <ModalFeedBack /> : null}
        {modal?.type === 'newticket' ? <ModalNewTicket /> : null}
        {modal?.type === 'term' ? <ModalTerm /> : null}
        {modal?.type === 'welcome' ? <ModalWelcome /> : null}
        {modal?.type === 'share' ? <ModalShare /> : null}
        {modal?.type === 'upload' ? <ModalUpload /> : null}
        {['pdf-preview', 'image-preview', 'video-preview'].includes(modal?.type) ? <ModalPdfPreview /> : null}
        {modal?.type === 'web-notification' ? <ModalWebNotification /> : null}
        {modal?.type === 'exclusive-content' ? <ModalExclusiveContent /> : null}
      </ThemedComponent>
    </>
  )
}
